module.exports = __webpack_public_path__ + "img/Fosshub.48002ff1.svg";